import type { FaireProductEntity } from "../../entity_types/product";

export const p_2cuzgb3xzm: FaireProductEntity = {
  token: "p_2cuzgb3xzm",
  type: "product",
  name: "Hello Kitty Holiday Decoration Building Kit",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/dc2ba73f6afd5ce5c520de3da785e88e6243e2e410a827a4d2941d250c5eac7d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e70e79a5c63e25f590df24bf0d70243ffac8717b30049e0657115859d53423fe.jpeg",
    "https://cdn.faire.com/fastly/dea9df2a1ae2f3a004b873996283efc43b1d6b8f1d86e9fce5c6b49576832277.jpeg",
    "https://cdn.faire.com/fastly/781687966676c3f1283e1413733c9a3c230695ba18b66eeb41f32045e0e0e2bb.jpeg",
    "https://cdn.faire.com/fastly/d341e6df5b276a2247a6b222d112547b26db2d3db63a0d39483a5d197a3ac22f.jpeg",
    "https://cdn.faire.com/fastly/2e537f133bb393b3b70d8ef1e4fe14e47aaf5d45bf7c6c3a75f5926d9ceee728.jpeg",
    "https://cdn.faire.com/fastly/f79f2cf237115d493ab08d1c826ca643fd0282dcb23d8ec9cf6a783dca090203.jpeg",
    "https://cdn.faire.com/fastly/a8b16b5428fd064c07e57aa6566b81286d4b0879476c94e113177b0149a913bc.jpeg",
  ],
  priceDollars: 8.27,
  description:
    "Hello Kitty steps into the season in brick-built style, dressed in her Santa hat, green bow, and striped holiday scarf. Crisp printed details capture her sweet expression, while thoughtful shaping keeps her unmistakably Hello Kitty. With the included stand and hanging string, she’s ready to bring holiday charm to any spot you choose.",
  tags: [],
  msrpDollars: 16.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:56.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
